export enum VolumeUnit {
  CUBIC_MM = 'mm3',
  CUBIC_CM = 'cm3',
  CUBIC_DM = 'dm3',
  CUBIC_INCHES = 'in3',
  CUBIC_FEET = 'ft3',
  CUBIC_M = 'm3',
}
